export enum QuestionCategory {
  music = "Music",
  sport_and_leisure = "Sport & Leisure",
  film_and_tv = "Film & TV",
  arts_and_literature = "Arts & Literature",
  history = "History",
  society_and_culture = "Society & Culture",
  science = "Science",
  geography = "Geography",
  food_and_drink = "Food & Drink",
  general_knowledge = "General Knowledge",
}
